import axios from 'utils/axios';
import { put } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr'
import * as HitManager from 'actions/HitManager';
import i18n from 'i18n/i18n.js';

export function* onGetStudentInfoRequest({ payload, cb }) {
  try {

    const res = yield axios.get(`/api/company/student/${payload.id}`);

    yield put(HitManager.onGetStudentInfoSuccess({ response: res.data, id: payload.id }));

    cb && cb(null);
  } catch (e) {
    yield put(HitManager.onGetStudentInfoFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onGetReqProfileRequest({ payload, cb }) {
  try {

    const res = yield axios.get(`/api/company/reqProfile/${payload.id}`);

    yield put(HitManager.onGetReqProfileSuccess(res.data));

    cb && cb(null);
  } catch (e) {
    yield put(HitManager.onGetReqProfileFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onGetReqProfilesRequest({ cb }) {
  try {

    const res = yield axios.get(`/api/company/reqProfile/get`);

    yield put(HitManager.onGetReqProfilesSuccess(res.data));

    cb && cb(null);
  } catch (e) {
    yield put(HitManager.onGetReqProfilesFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onCreateReqProfileRequest({ payload, cb }) {
  
  try {

    const res = yield axios.post(`/api/company/reqProfile/create`, payload);

    yield put(HitManager.onCreateReqProfileSuccess(res.data));
    toastr.success(i18n.t('toastr.onCreateReqProfileSuccess.title'), i18n.t('toastr.onCreateReqProfileSuccess.body'))

    cb && cb(null);
  } catch (e) {
    yield put(HitManager.onCreateReqProfileFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onGetStudentsInReqProfileRequest({ payload, cb }) { 
  try {

    const res = yield axios.get(`/api/company/reqProfile/${payload.reqProfileId}/studentReqProfiles?page=${payload.page || 0}&size=${payload.size || 10}${payload.orderBy ? '&sort=' + payload.orderBy + ',' + payload.orderDirection : ''}`);

    yield put(HitManager.onGetStudentsInReqProfileSuccess(res.data));

    cb && cb(null);
  } catch (e) {
    yield put(HitManager.onGetStudentsInReqProfileFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onGetStudentsInReqProfilesRequest({ payload, cb }) { 
  try {

    const res = yield axios.get(`/api/company/reqProfile/studentReqProfile/getAll?page=${payload.page || 0}&size=${payload.size || 10}${payload.orderBy ? '&sort=' + payload.orderBy + ',' + payload.orderDirection : ''}`);

    yield put(HitManager.onGetStudentsInReqProfilesSuccess(res.data));

    cb && cb(null);
  } catch (e) {
    yield put(HitManager.onGetStudentsInReqProfilesFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onGetHitActionsRequest({ payload, cb }) { 
  try {

    const res = yield axios.get(`/api/companyUser/hitAction/get?page=${payload.page || 0}&size=${payload.size || 10}${payload.orderBy ? '&sort=' + payload.orderBy + ',' + payload.orderDirection : ''}`);

    yield put(HitManager.onGetHitActionsSuccess(res.data));

    cb && cb(null);
  } catch (e) {
    yield put(HitManager.onGetHitActionsFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onGetStudentInfoLogRequest({ payload, cb }) { 

  const { studentId } = payload;

  try {

    const res = yield axios.get(`/api/company/student/${studentId}/log`);

    yield put(HitManager.onGetStudentInfoLogSuccess({ data: res.data, studentId: studentId} ));

    cb && cb(null);
  } catch (e) {
    yield put(HitManager.onGetStudentInfoLogFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onUpdateReqProfileRequest({ payload, cb }) { 
  try {

    const res = yield axios.post(`/api/company/reqProfile/update`, payload);

    yield put(HitManager.onUpdateReqProfileSuccess(res.data));

    cb && cb(null);
  } catch (e) {
    yield put(HitManager.onUpdateReqProfileFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onUpdateHitActionRequest({ payload, cb }) { 
  try {

    const res = yield axios.post(`/api/companyUser/hitAction/update`, payload);

    yield put(HitManager.onUpdateHitActionSuccess(res.data));

    cb && cb(null);
  } catch (e) {
    yield put(HitManager.onUpdateHitActionFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onGetNonUpdatedStudentsInReqProfilesRequest({ payload, cb }) { 
  try {

    const res = yield axios.get(`/api/company/reqProfile/studentReqProfile/getNonUpdated?page=${payload.page || 0}&size=${payload.size || 10}${payload.orderBy ? '&sort=' + payload.orderBy + ',' + payload.orderDirection : ''}`);

    yield put(HitManager.onGetNonUpdatedStudentsInReqProfilesSuccess(res.data));

    cb && cb(null);
  } catch (e) {
    yield put(HitManager.onGetNonUpdatedStudentsInReqProfilesFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onSearchStudentsInReqProfilesRequest({ payload, cb }) { 
  try {

    const res = yield axios.get(`/api/company/reqProfile/studentReqProfile/getAll/search?q=${payload.searchQuery}&page=${payload.page || 0}&size=${payload.size || 10}${payload.orderBy ? '&sort=' + payload.orderBy + ',' + payload.orderDirection : ''}`);

    yield put(HitManager.onSearchStudentsInReqProfilesSuccess(res.data));

    cb && cb(null);
  } catch (e) {
    yield put(HitManager.onSearchStudentsInReqProfilesFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onSearchStudentsInReqProfileRequest({ payload, cb }) { 
  try {
    const res = yield axios.get(`/api/company/reqProfile/studentReqProfile/${payload.reqProfileId}/search?q=${payload.searchQuery}&page=${payload.page || 0}&size=${payload.size || 10}${payload.orderBy ? '&sort=' + payload.orderBy + ',' + payload.orderDirection : ''}`)

    yield put(HitManager.onSearchStudentsInReqProfileSuccess({ data: res.data, reqProfileId: payload.reqProfileId }));

    cb && cb(null);
  } catch (e) {
    yield put(HitManager.onSearchStudentsInReqProfileFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onAddStudentsToReqProfileRequest({ payload, cb }) {
  try {
    const res = yield axios.post(`/api/company/reqProfile/addStudentReqProfiles`, payload);

    yield put(HitManager.onAddStudentsToReqProfileSuccess(res.data));
    toastr.success(i18n.t('toastr.onAddStudentsToReqProfileSuccess.title'), i18n.t('toastr.onAddStudentsToReqProfileSuccess.body'))

    cb && cb(null);
  } catch (e) {
    yield put(HitManager.onAddStudentsToReqProfileFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onAddHitActionRequest({ payload, cb }) {
  try {

    const res = yield axios.post(`/api/companyUser/hitAction/create`, payload);

    yield put(HitManager.onAddHitActionSuccess(res.data));
    toastr.success(i18n.t('toastr.onAddHitActionSuccess.title'), i18n.t('toastr.onAddHitActionSuccess.body'))

    cb && cb(null);
  } catch (e) {
    yield put(HitManager.onAddHitActionFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onUpdateStudentInReqProfileRequest({ payload, cb }) {

  const studentReqProfileStatusOld = payload.studentReqProfileStatusOld
  const queryString = payload
  delete queryString['studentReqProfileStatusOld'];

  try {

    const res = yield axios.post(`/api/company/reqProfile/updateStudentReqProfile`, queryString);

    yield put(HitManager.onUpdateStudentInReqProfileSuccess({ response: res.data, oldStatus: studentReqProfileStatusOld})); // For individual reqProfile
    yield put(HitManager.onUpdateStudentInReqProfilesSuccess({ response: res.data, oldStatus: studentReqProfileStatusOld})); // For master list
    yield put(HitManager.onUpdateNonUpdatedStudentInReqProfilesSuccess({ response: res.data, oldStatus: studentReqProfileStatusOld})); // For non updated student list
    
    toastr.success(i18n.t('toastr.onUpdateStudentInReqProfileSuccess.title'), i18n.t('toastr.onUpdateStudentInReqProfileSuccess.body'))

    cb && cb(null);
  } catch (e) {
    yield put(HitManager.onUpdateStudentInReqProfileFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onDeleteStudentsFromReqProfileRequest({ payload, cb }) {
  try {

    yield axios.delete(`/api/company/reqProfile/deleteStudentReqProfiles`, { data: payload.data });

    yield put(HitManager.onDeleteStudentsFromReqProfileSuccess(payload));
    yield put(HitManager.onDeleteStudentsFromReqProfilesSuccess(payload));

    cb && cb(null);
  } catch (e) {
    yield put(HitManager.onDeleteStudentsFromReqProfileFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onDeleteReqProfileRequest({ payload, cb }) {
  try {

    yield axios.delete(`/api/company/reqProfile/delete`, { data: payload });

    yield put(HitManager.onDeleteReqProfileSuccess(payload));

    toastr.success(i18n.t('toastr.onDeleteReqProfileSuccess.title'), i18n.t('toastr.onDeleteReqProfileSuccess.body'))

    cb && cb(null);
  } catch (e) {
    yield put(HitManager.onDeleteReqProfileFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onDeleteHitActionRequest({ payload, cb }) {
  try {

    yield axios.delete(`/api/companyUser/hitAction/delete`, { data: payload });

    yield put(HitManager.onDeleteHitActionSuccess(payload));

    toastr.success(i18n.t('toastr.onDeleteHitActionSuccess.title'), i18n.t('toastr.onDeleteHitActionSuccess.body'))
    
    cb && cb(null);
  } catch (e) {
    yield put(HitManager.onDeleteHitActionFailure({ message: e.toString() }));
    cb && cb(e);
  }
}
